import { useNavigate, Link } from 'react-router-dom';
import styled from 'styled-components';

import { EquityCurve } from '../components/charts/EquityCurve';
import { Button } from '../components/primitives/Button';
import { Container } from '../components/primitives/Container';
import { equityCurve } from '../lib/equity-curve';

const Split = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: ${(p) => p.theme.step[7]}px;
  padding: ${(p) => p.theme.step[7]}px 0;
  align-items: center;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 360px;
`;

const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: ${(p) => p.theme.step[1]}px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${(p) => p.theme.color.text[3]};

  input {
    background: ${(p) => p.theme.color.bg[2]};
    border: 1px solid ${(p) => p.theme.color.border.med};
    color: ${(p) => p.theme.color.text[0]};
    border-radius: 6px;
    padding: 10px 12px;
    font-family: inherit;
    font-size: ${(p) => p.theme.step[3]}px;
    text-transform: none;
    letter-spacing: 0;
  }
`;

export default function Login() {
  const nav = useNavigate();
  const data = equityCurve({ seed: 11, steps: 240 });
  return (
    <Container>
      <Split>
        <div>
          <h1 style={{ fontFamily: 'var(--font-serif)', margin: 0 }}>Sign in</h1>
          <p style={{ color: 'var(--text-2)' }}>Mock auth — anything works.</p>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              nav('/dashboard');
            }}
          >
            <Field>
              Email
              <input type="email" required defaultValue="trader@powerquant.com" />
            </Field>
            <Field>
              Password
              <input type="password" required defaultValue="••••••••" />
            </Field>
            <Button type="submit" $variant="primary">
              Sign in
            </Button>
            <p style={{ color: 'var(--text-3)', fontSize: 12 }}>
              No account? <Link to="/signup">Create one</Link>.
            </p>
          </Form>
        </div>
        <EquityCurve data={data} height={320} />
      </Split>
    </Container>
  );
}
